// src/services/eventInventoryApi.ts
import apiClient from "./apiClient";

export const getEventInventory = async (eventId: string) => {
  const { data } = await apiClient.get(`/eventInventory/${eventId}`);
  return data as any[];
};

export const allocateMultipleInventories = (
  eventId: string,
  inventoryItems: { inventoryItemId: string; allocatedQuantity: number }[]
) => apiClient.post("/eventInventory/allocate", { eventId, inventoryItems });

export const removeAllocatedInventory = (eventInventoryId: string) =>
  apiClient.delete(`/eventInventory/${eventInventoryId}`);

export const updateEventInventory = (id: string, updates: any) =>
  apiClient.put(`/eventInventory/${id}`, updates);

export const sellItemInEvent = (payload: {
  eventId: string;
  inventoryItemId: string;
  soldQuantity: number;
  sellingPrice?: number;
  bundleSale?: boolean;
}) => apiClient.post("/eventInventory/sell", payload);

export const reallocateUnusedInventory = (eventId: string) =>
  apiClient.post(`/eventInventory/${eventId}`);
